export const makePaintStyle = ({
  layer, styleType, forceDots, hasNewLayers,
}) => {
  const opacity = layer.isNew || !hasNewLayers ? layer.style.opacity || 0.8 : 0.6;
  if (!forceDots || styleType === 'circle') {
    const paint = {
      ...layer.style.paint,
      [`${styleType}-opacity`]: opacity,
    };
    return paint;
  }

  const paint = {
    'circle-radius': 4,
    'circle-color': layer.style.paint[`${styleType}-color`],
    'circle-opacity': opacity,
  };
  return paint;
};
